/**
 * Read a public env var, preferring the `PUBLIC_`-prefixed name and falling
 * back to the legacy `VITE_` name. Returns a trimmed string, or "" if unset.
 * The caller passes `import.meta.env` so this stays free of Vite types.
 */
export function readEnv(
  env: Record<string, unknown>,
  primary: string,
  fallback: string
): string {
  const value = env[primary] || env[fallback];
  return typeof value === "string" && value.trim().length > 0 ? value.trim() : "";
}
